import { Fragment, ReactElement } from 'react';

import { usePopover } from './hooks';

import {
  PopoverContainer,
  KebabItemButton,
  KebabItemText,
  StyledPopover,
} from './Filters.components';
import { HeaderButton } from '../buttons';
import { removeAuthToken } from '@/features/auth';

export const ProfileMenu = (): ReactElement => {
  const { isOpen, id, anchorEl, toggle, close } = usePopover('profile-popover');

  const handleLogout = () => {
    removeAuthToken();
    window.location.replace(ENV.DEV_HOST as string);
  };

  return (
    <Fragment>
      <HeaderButton onClick={toggle}>
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.6982 28C25.6982 25.6131 24.75 23.3239 23.0622 21.636C21.3744 19.9482 19.0852 19 16.6982 19M16.6982 19C14.3113 19 12.0221 19.9482 10.3343 21.636C8.64645 23.3239 7.69824 25.6131 7.69824 28M16.6982 19C20.012 19 22.6982 16.3137 22.6982 13C22.6982 9.68629 20.012 7 16.6982 7C13.3845 7 10.6982 9.68629 10.6982 13C10.6982 16.3137 13.3845 19 16.6982 19ZM31.6982 16C31.6982 24.2843 24.9825 31 16.6982 31C8.41397 31 1.69824 24.2843 1.69824 16C1.69824 7.71573 8.41397 1 16.6982 1C24.9825 1 31.6982 7.71573 31.6982 16Z"
            stroke="#EDEEF7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </HeaderButton>

      <StyledPopover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ zIndex: 10 }}
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={close}
      >
        <PopoverContainer>
          <KebabItemButton>
            <KebabItemText primary={'Logout'} onClick={() => handleLogout()} />
          </KebabItemButton>
        </PopoverContainer>
      </StyledPopover>
    </Fragment>
  );
};
